<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="80px"
    >
      <el-form-item label="订单编号" prop="orderId">
        <el-input
          v-model="queryParams.orderId"
          class="!w-160px"
          clearable
          placeholder="订单 ID"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="用户编号" prop="userId">
        <el-input
          v-model="queryParams.userId"
          class="!w-140px"
          clearable
          placeholder="用户 ID"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="店铺编号" prop="shopId">
        <el-input
          v-model="queryParams.shopId"
          class="!w-140px"
          clearable
          placeholder="店铺 ID"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-160px" clearable placeholder="全部">
          <el-option
            v-for="item in DEPOSIT_CANCEL_STATUS"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          class="!w-240px"
          end-placeholder="结束"
          start-placeholder="开始"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" :show-overflow-tooltip="true">
      <el-table-column align="center" label="编号" prop="id" width="80" />
      <el-table-column align="center" label="申请单号" prop="no" min-width="160" />
      <el-table-column align="center" label="订单编号" prop="orderId" width="110">
        <template #default="{ row }">
          <el-button link type="primary" @click="openOrderDetail(row.orderId)">
            {{ row.orderId }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户" prop="userId" width="100" />
      <el-table-column align="center" label="店铺" prop="shopId" width="100" />
      <el-table-column align="center" label="定金" prop="depositPrice" width="100">
        <template #default="{ row }">{{ fenToYuan(row.depositPrice) }} 元</template>
      </el-table-column>
      <el-table-column align="left" label="申请原因" prop="applyReason" min-width="140" />
      <el-table-column align="center" label="状态" width="130">
        <template #default="{ row }">
          <el-tag :type="statusTagType(row.status)" size="small">
            {{ getDepositCancelStatusLabel(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="申请时间"
        prop="createTime"
        :formatter="dateFormatter"
        width="170"
      />
      <el-table-column align="center" label="操作" width="200" fixed="right">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['trade:order:query']"
            link
            type="primary"
            @click="openDetail(row)"
          >
            详情
          </el-button>
          <el-button
            v-if="row.status === 0"
            v-hasPermi="['trade:order:update']"
            link
            type="warning"
            @click="openAudit(row)"
          >
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <el-drawer v-model="detailVisible" title="退定金申请详情" size="480px">
    <template v-if="detail">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="申请单号">{{ detail.no }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ detail.orderId }}</el-descriptions-item>
        <el-descriptions-item label="用户编号">{{ detail.userId }}</el-descriptions-item>
        <el-descriptions-item label="店铺编号">{{ detail.shopId }}</el-descriptions-item>
        <el-descriptions-item label="定金">
          {{ fenToYuan(detail.depositPrice) }} 元
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          {{ getDepositCancelStatusLabel(detail.status) }}
        </el-descriptions-item>
        <el-descriptions-item label="申请原因">
          {{ detail.applyReason || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核备注">
          {{ detail.auditReason || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ detail.auditTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="退款单">{{ detail.payRefundId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ detail.createTime }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="detail.status === 0" class="mt-16px flex justify-end gap-8px">
        <el-button
          v-hasPermi="['trade:order:update']"
          type="warning"
          @click="openAudit(detail)"
        >
          去审核
        </el-button>
      </div>
    </template>
  </el-drawer>

  <Dialog v-model="auditVisible" title="退定金三态审核" width="520px">
    <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="100px">
      <el-form-item label="审核结果" prop="auditResult">
        <el-radio-group v-model="auditForm.auditResult">
          <el-radio :value="1">通过并退定金</el-radio>
          <el-radio :value="2">通过不退定金</el-radio>
          <el-radio :value="3">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核备注" prop="auditReason">
        <el-input
          v-model="auditForm.auditReason"
          type="textarea"
          :rows="3"
          maxlength="200"
          show-word-limit
          :placeholder="auditReasonPlaceholder"
        />
      </el-form-item>
      <el-alert
        :title="auditTip"
        type="info"
        :closable="false"
        show-icon
        class="mb-12px"
      />
    </el-form>
    <template #footer>
      <el-button @click="auditVisible = false">取消</el-button>
      <el-button type="primary" :loading="auditLoading" @click="submitAudit">确定</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import { fenToYuan } from '@/utils'
import * as DepositCancelApi from '@/api/mall/trade/presaleDepositCancel'
import {
  DEPOSIT_CANCEL_STATUS,
  getDepositCancelStatusLabel,
  type PresaleDepositCancelVO
} from '@/api/mall/trade/presaleDepositCancel'

defineOptions({ name: 'TradePresaleDepositCancel' })

const message = useMessage()
const { push } = useRouter()

const loading = ref(false)
const list = ref<PresaleDepositCancelVO[]>([])
const total = ref(0)
const queryFormRef = ref()
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  orderId: undefined as string | number | undefined,
  userId: undefined as string | number | undefined,
  shopId: undefined as string | number | undefined,
  status: undefined as number | undefined,
  createTime: undefined as string[] | undefined
})

const detailVisible = ref(false)
const detail = ref<PresaleDepositCancelVO>()

const auditVisible = ref(false)
const auditLoading = ref(false)
const auditFormRef = ref()
const auditForm = reactive({
  id: undefined as number | undefined,
  auditResult: 1 as number,
  auditReason: ''
})
const auditRules = {
  auditResult: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
  auditReason: [
    {
      validator: (_: any, value: string, callback: (e?: Error) => void) => {
        if (auditForm.auditResult === 3 && !value?.trim()) {
          callback(new Error('驳回时请填写原因'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

const auditReasonPlaceholder = computed(() => {
  if (auditForm.auditResult === 3) return '请填写驳回原因'
  if (auditForm.auditResult === 2) return '可选：说明不退定金原因'
  return '可选：审核备注'
})

const auditTip = computed(() => {
  if (auditForm.auditResult === 1) return '通过并退定金：发起定金退款，退款成功后自动关单'
  if (auditForm.auditResult === 2) return '通过不退定金：立即关单，定金不退还'
  return '驳回：用户可继续支付尾款，或再次申请'
})

const statusTagType = (status?: number) => {
  if (status === 0) return 'warning'
  if (status === 10) return ''
  if (status === 30) return 'danger'
  if (status === 20 || status === 40) return 'success'
  return 'info'
}

const getList = async () => {
  loading.value = true
  try {
    const params = {
      ...queryParams,
      orderId: queryParams.orderId ? Number(queryParams.orderId) : undefined,
      userId: queryParams.userId ? Number(queryParams.userId) : undefined,
      shopId: queryParams.shopId ? Number(queryParams.shopId) : undefined
    }
    const data = await DepositCancelApi.getDepositCancelPage(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const openOrderDetail = (orderId?: number) => {
  if (!orderId) return
  push({ name: 'TradeOrderDetail', params: { id: orderId } })
}

const openDetail = async (row: PresaleDepositCancelVO) => {
  if (!row.id) return
  detail.value = await DepositCancelApi.getDepositCancel(row.id)
  detailVisible.value = true
}

const openAudit = (row: PresaleDepositCancelVO) => {
  if (!row.id) return
  auditForm.id = row.id
  auditForm.auditResult = 1
  auditForm.auditReason = ''
  auditVisible.value = true
}

const submitAudit = async () => {
  await auditFormRef.value?.validate()
  if (!auditForm.id) return
  auditLoading.value = true
  try {
    await DepositCancelApi.auditDepositCancel({
      id: auditForm.id,
      auditResult: auditForm.auditResult,
      auditReason: auditForm.auditReason?.trim() || undefined
    })
    message.success('审核已提交')
    auditVisible.value = false
    detailVisible.value = false
    await getList()
  } finally {
    auditLoading.value = false
  }
}

onMounted(() => {
  getList()
})
</script>
